export const betbyScript = (libraryUrl: string) => `
!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    t.onload = execCactusEvents('betby');
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  '${libraryUrl}',
  "betby-script"
  );
`;
